import { gql } from "@apollo/client";

export default gql`
  mutation resolveAiHelpGaps($data: AiHelpResolveGapsInput!){
    resolveAiHelpGaps(data: $data){
        success
        data
        code
        message
    }
}
`
